import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: 'under-construction',
    loadChildren: () =>
      import('@offconon/domain/page/under-construction').then((m) => m.underConstructionRoutes),
  },
  {
    path: '',
    loadChildren: () =>
      import('@offconon/domain/feature/domain-shell').then((m) => m.domainShellModuleRoutes),
  },
  {
    path: 'not-found',
    redirectTo: 'under-construction',
  },
  {
    path: '**',
    redirectTo: '',
  },
];
